<template>
  <v-card
    style="height=100%"
    color="wall"
    class="order-resume"
    id="orderResume"
  >
    <v-toolbar color="secondary" dense dark flat>
      <v-container>
        <v-row justify="center">Resumen de Listado</v-row>
      </v-container>
    </v-toolbar>

    <v-container fluid class="order-container">
      <v-row class="order-resume-row">
        <v-col cols="9">Total de artículos</v-col>
        <v-col cols="3" class="num-col">{{ artQuantity }}</v-col>
      </v-row>

      <v-divider></v-divider>

      <v-row class="order-resume-row">
        <v-col cols="9">Total de piezas</v-col>
        <v-col cols="3" class="num-col">{{ pieceQuantity }}</v-col>
      </v-row>

      <v-divider></v-divider>

      <v-row class="justify-center pb-2 mt-2">
        <btnCotizar
          :products="products"
          :session="session"
          :snackbar="snackbar"
        >
        </btnCotizar>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import btnCotizar from "./quickorderResumeListadoBtnCotizar.vue";
import { isActiveSession } from "../../utils/util";

export default {
  components: { btnCotizar },

  data() {
    return {
      dialog: false,
      artQuantity: 0,
      pieceQuantity: 0,
      comment: "",
      session: isActiveSession(),
    };
  },

  props: {
    updateShopingQuantity: { type: Function },
    products: { type: Array },
    snackbar: { type: Function },
  },

  methods: {
    actualizarContadores: function () {
      var items = this.products;
      this.artQuantity = items.length;
      this.pieceQuantity = items.reduce(function (previousValue, currentValue) {
        return Number(previousValue) + Number(currentValue.quantity);
      }, 0);
    },
  },

  computed: {},

  watch: {},

  created() {
    this.actualizarContadores();
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
.num-col {
  display: flex;
  justify-content: flex-end;
}

.order-resume-row {
  margin-left: 3%;
  margin-right: 3%;
  margin-top: 4%;
  margin-bottom: 4%;
  font-weight: bold;
}

.order-container {
  background-color: #ebebeb;
}

.order-container .col {
  padding: 0px 12px;
}

.order-container .col .code {
  padding-left: 20px;
  padding-right: 12px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
